import { useParams } from 'react-router-dom'

export interface ISubscriptionParams {
  subscriptionId: string
}

export const useSubscriptionParams = () => useParams<ISubscriptionParams>()
